"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_fade = void 0;
exports.foundation_fade = {
    fade: {
        fade_100: 1,
        fade_0: 0,
    },
};
//# sourceMappingURL=fade.js.map